/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {useQuery} from '@tanstack/react-query'

import {getAccessories, getAccessoryById} from './api'
import {accessoryKeys} from './keys'
import {AccessoryResponse} from './types'

export const useAccessories = () => {
  return useQuery<AccessoryResponse[], unknown>({
    queryKey: accessoryKeys.lists(),
    queryFn: () => getAccessories(),
  })
}

export const useAccessory = (id?: string) => {
  return useQuery<AccessoryResponse, unknown>({
    queryKey: accessoryKeys.detail(id || ''),
    queryFn: () => getAccessoryById(id!),
    enabled: !!id,
  })
}
